import React, { useEffect, useState } from "react";
import clock from "../../assests/clock.svg";

export default function TimerWidget2({ endTime }) {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  useEffect(() => {
    setTimeLeft(getTimeLeft());
    const intervalId = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 60000);

    return () => clearInterval(intervalId);
  }, [endTime]);

  function getTimeLeft() {
    const totalSeconds = Math.round((new Date(endTime) - new Date()) / 1000);

    if (totalSeconds <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
      };
    }
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    return {
      days,
      hours,
      minutes,
      seconds,
      totalSeconds,
    };
  }
  return (
    <div className="template-counter">
      <div className="template-tick">
        <img src={clock} />
      </div>
      {timeLeft?.totalSeconds >= 0 ? (
        <>
          <p className="template-text-large-medium">Hurry & Join Us Now! </p>
          <div className="template-time-container">
            <div className="template-text-time ">
              <p>{timeLeft?.days}</p>
              <p className="template-time-subtext ">Days</p>
            </div>
            <div className="template-text-time ">
              <p> {timeLeft?.hours}</p>
              <p className="template-time-subtext">Hrs</p>
            </div>
            <div className="template-text-time ">
              <p> {timeLeft?.minutes} </p>
              <p className="template-time-subtext ">Min</p>
            </div>
          </div>
        </>
      ) : (
        <p className="template-time-subtext">Submission period ended</p>
      )}
    </div>
  );
}
